import { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../components/ui/dialog';
import { request } from './editorial-client';

export default function EditQueuedTitle({target,onClose,onSaved}:{target:{id:string;title:string;token:string};onClose:()=>void;onSaved:()=>Promise<unknown>}) {
  const [title,setTitle]=useState(target.title);
  const [busy,setBusy]=useState(false);
  const [error,setError]=useState('');
  async function finish(save:boolean) {
    setBusy(true);setError('');
    try {
      await request('POST',{action:save?'save-title':'cancel-title-edit',runId:target.id,token:target.token,...(save?{title}:{})});
      await onSaved();onClose();
    } catch(e) {setError(e instanceof Error?e.message:'Could not update title.'); if(!save){await onSaved();onClose();}}
    finally {setBusy(false);}
  }
  return <Dialog open onOpenChange={open=>{if(!open&&!busy)void finish(false);}}><DialogContent className="max-w-lg">
    <DialogTitle>Edit queued title</DialogTitle>
    <DialogDescription>The brief and sections will be rebuilt to match. This idea is held for up to 15 minutes while you edit.</DialogDescription>
    <form className="space-y-4" onSubmit={event=>{event.preventDefault();void finish(true);}}>
      <label className="block space-y-2"><span>Title</span><textarea className="w-full rounded-md border bg-background p-3" rows={3} minLength={8} maxLength={200} required value={title} onChange={event=>setTitle(event.target.value)} disabled={busy} /></label>
      {error&&<p role="alert" className="desk-error">{error}</p>}
      <div className="flex flex-wrap gap-2"><button className="desk-button" type="submit" disabled={busy}>{busy?'Saving…':'Save & rebuild brief'}</button><button className="desk-button secondary" type="button" disabled={busy} onClick={()=>void finish(false)}>Cancel</button></div>
    </form>
  </DialogContent></Dialog>;
}
